<div class="dialog-main-content">
    <div class="full-width modal-main-div">

        <mat-accordion #accordion hideToggle>
            <mat-expansion-panel *ngFor="let expansion of modalData" expanded="false">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <span>
                            {{ expansion.version }}
                        </span>
                        <span class="expansion-date">
                            {{ expansion.releaseOn | date:'YYYY/MM/dd' }}
                        </span>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="content" [innerHTML]="expansion.content | safeHtml">
                </div>

            </mat-expansion-panel>
        </mat-accordion>
    </div>
</div>